import { resetStore, store } from './store';
import apiClient from './utils/axios';
import { hasToken } from './store';
import crispService from './services/crisp';
import * as Sentry from '@sentry/vue';
import { isMobile } from './store';
/**
 * Confirm that the user is authenticated by making a request to the / endpoint.
 * @returns {Promise<boolean>} - Returns true if the user is authenticated, false otherwise.
 */
export async function confirmAuth(): Promise<boolean> {
  if (!hasToken()) {
    store.isAuthenticated = false;
    return false;
  }
  try {
    const response = await apiClient.get('https://api.nevua.markets/users/settings');
    
    if (response.status === 200) {
      store.isAuthenticated = true;

      store.telegramChatId = response.data.telegramChatId || null;
      store.telegramNonce = response.data.telegramNonce;
      store.paid = response.data.paid;
      
      return true;
    } else {
      throw new Error('Authentication failed');
    }

  } catch (error: any) {
    if (error?.response?.status === 401) {
      localStorage.removeItem('jwtToken');

      resetStore();
      crispService.client.session.reset()
      store.isAuthenticated = false;
    } else {
      Sentry.setExtra('method', 'confirmAuth');
      Sentry.captureException(error);
    }

    return false;
  }
}

export default confirmAuth;